export const CertificateIcon = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2961 17.7191C20.9656 15.9506 23.1014 13.4271 24.1986 10.3287C25.2957 7.23028 23.1491 2.54516 16.5145 3.27409C9.87983 4.00303 1.01224 10.0606 4.25059 22.9817C5.87809 30.6691 13.5332 34.0182 22.072 31.4674C26.8003 29.8455 32.5489 26.0533 32.5925 21.0967C32.6068 19.4739 31.974 17.2915 29.7736 17.2848C26.3334 17.2939 26.1014 19.8481 23.2961 17.7191Z"
        fill="#E5EBF7"
      />
      <path
        d="M16.3142 13.9381C16.3003 13.6228 16.5447 13.3559 16.8599 13.3421L27.8275 12.8594C29.0887 12.8039 30.156 13.7813 30.2115 15.0424L30.8266 29.0193C30.8405 29.3346 30.5961 29.6014 30.2808 29.6153L17.6006 30.1733C17.2853 30.1872 17.0185 29.9428 17.0046 29.6275L16.3142 13.9381Z"
        fill="#BACEF5"
        fillOpacity="0.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8591 10.9149C17.5443 10.8928 17.2712 11.1302 17.2492 11.445L16.0534 28.5461C16.0314 28.861 16.2687 29.134 16.5836 29.156L28.5543 29.9931C28.8691 30.0151 29.1422 29.7778 29.1642 29.4629L30.36 12.3618C30.3821 12.047 30.1447 11.774 29.8299 11.7519L17.8591 10.9149ZM29.8273 11.7524L28.1172 11.6328L27.9976 13.3429C27.9756 13.6577 28.213 13.9308 28.5278 13.9528L30.2379 14.0724L30.3575 12.3623C30.3795 12.0475 30.1421 11.7744 29.8273 11.7524Z"
        fill="#4E81E9"
      />
      <path
        d="M28.1172 11.6406L29.1775 12.8604L30.2379 14.0802L28.5278 13.9606C28.213 13.9386 27.9756 13.6656 27.9976 13.3507L28.1172 11.6406Z"
        fill="#A8CBF9"
      />
      <path
        d="M19.3076 14.4541L27.8582 15.052"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M19.1682 16.4492L27.7188 17.0471"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M19.0286 18.4443L27.5791 19.0422"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M18.8892 20.4395L27.4397 21.0374"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M18.7495 22.4346L27.3001 23.0325"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M18.6101 24.4297L27.1607 25.0276"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M18.4705 26.4248L27.021 27.0227"
        stroke="#B7CFF2"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M3.56923 12.0492C3.40587 11.4396 3.76768 10.8129 4.37735 10.6495L11.7898 8.66337C16.4932 7.40308 21.3278 10.1943 22.5881 14.8978L25.6048 26.1563C25.7681 26.7659 25.4063 27.3926 24.7966 27.556L9.9718 31.5283C9.36212 31.6916 8.73545 31.3298 8.57209 30.7202L3.56923 12.0492Z"
        fill="#BDD0F3"
        fillOpacity="0.6"
      />
      <rect
        x="4.67188"
        y="9.89062"
        width="17.7143"
        height="21.7143"
        rx="1.14286"
        transform="rotate(-11 4.67188 9.89062)"
        fill="#FFFFFE"
      />
      <rect
        x="6.52344"
        y="12.2812"
        width="2.85714"
        height="2.85714"
        rx="0.571429"
        transform="rotate(-11 6.52344 12.2812)"
        fill="#78CFBD"
      />
      <path
        d="M11.1218 11.9634L20.6576 10.1098"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M11.5034 13.9265L21.0392 12.0729"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M7.9585 16.6531L21.4208 14.0363"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M8.34009 18.6162L21.8024 15.9994"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M8.72168 20.5796L22.184 17.9628"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M9.10352 22.5427L22.5658 19.9259"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M9.48511 24.5061L22.9474 21.8893"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M9.8667 26.4692L23.329 23.8524"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <path
        d="M10.2483 28.4326L23.7106 25.8158"
        stroke="#E5EBF7"
        strokeWidth="0.857143"
        strokeLinecap="round"
      />
      <circle
        cx="7.9348"
        cy="21.0245"
        r="3.14286"
        transform="rotate(-11 7.9348 21.0245)"
        fill="#BACEF5"
        fillOpacity="0.6"
      />
      <circle
        cx="8.38792"
        cy="20.3526"
        r="3.14286"
        transform="rotate(-11 8.38792 20.3526)"
        fill="#F1C274"
      />
      <ellipse
        cx="23.8264"
        cy="24.1032"
        rx="3.85714"
        ry="3.89509"
        transform="rotate(-11 23.8264 24.1032)"
        fill="#BACEF5"
        fillOpacity="0.6"
      />
      <path
        d="M26.4531 28.3672L27.7964 27.3021L31.7018 32.2273C31.8979 32.4746 31.8563 32.834 31.6091 33.0301L31.1613 33.3852C30.914 33.5812 30.5546 33.5397 30.3585 33.2924L26.4531 28.3672Z"
        fill="#BACEF5"
        fillOpacity="0.6"
      />
      <circle
        cx="26.5059"
        cy="7.23315"
        r="0.571429"
        transform="rotate(-11 26.5059 7.23315)"
        fill="#76CFBC"
      />
      <circle
        cx="3.6993"
        cy="18.646"
        r="1.14286"
        transform="rotate(-11 3.6993 18.646)"
        fill="#F1C274"
      />
      <circle
        cx="4.83403"
        cy="15.5066"
        r="0.571429"
        transform="rotate(-11 4.83403 15.5066)"
        fill="#F1C274"
      />
      <rect
        x="25.2344"
        y="26.7109"
        width="1.14286"
        height="1.71429"
        transform="rotate(-38.4121 25.2344 26.7109)"
        fill="#4D4C4F"
      />
      <path
        d="M25.7969 27.8906L27.1401 26.8255L31.0455 31.7508C31.2416 31.9981 31.2001 32.3575 30.9528 32.5536L30.5051 32.9086C30.2578 33.1047 29.8983 33.0632 29.7023 32.8159L25.7969 27.8906Z"
        fill="#5E5E5E"
      />
      <path
        d="M7.15488 21.4625L8.15983 22.1403L9.80386 18.6191"
        stroke="white"
        strokeWidth="0.571429"
        strokeLinecap="round"
      />
      <circle
        cx="23.2757"
        cy="23.5695"
        r="3.57143"
        transform="rotate(-11 23.2757 23.5695)"
        fill="white"
        stroke="#616362"
        strokeWidth="0.857143"
      />
      <path
        d="M21.4688 26.25L25.9562 25.3777"
        stroke="#E5EBF7"
        strokeWidth="1.14286"
        strokeLinecap="round"
      />
      <path
        d="M20.5938 21.7656L25.0812 20.8934"
        stroke="#E5EBF7"
        strokeWidth="1.14286"
        strokeLinecap="round"
      />
      <circle
        cx="23.2757"
        cy="23.5695"
        r="3.57143"
        transform="rotate(-11 23.2757 23.5695)"
        stroke="#616362"
        strokeWidth="0.857143"
      />
      <path
        d="M21.7877 24.8453C22.089 24.3986 23.3148 22.2199 22.4734 22.3835C21.9125 22.4925 22.3049 24.3482 22.9203 24.5196C23.5358 24.6911 24.1679 22.6896 23.4202 23.1674C22.6387 23.6669 23.3309 24.348 23.7617 24.2789C24.3328 24.1872 24.6401 23.3841 24.4483 23.4406C24.0838 23.5482 24.8709 24.3759 25.2931 23.6143"
        stroke="#585858"
        strokeWidth="0.171429"
        strokeLinecap="round"
      />
      <circle
        cx="21.6333"
        cy="25.1079"
        r="0.0870536"
        transform="rotate(-11 21.6333 25.1079)"
        fill="#585858"
      />
      <circle
        cx="25.4614"
        cy="23.2329"
        r="0.0870536"
        transform="rotate(-11 25.4614 23.2329)"
        fill="#585858"
      />
    </svg>
  )
}
